import i18n from "i18next";
import common from "@optimusride/client-library/i18n/translations/en.json";
import { initReactI18next } from "react-i18next";
import appEn from "./translations/en.json";

const resources = {
    en: {
        translation: { ...common, ...appEn },
    },
};

export default i18n
    .use(initReactI18next)
    .init({
        lng: "en",
        resources,
        interpolation: {
            escapeValue: false,
        },
    });
